module.exports = __webpack_public_path__ + "static/media/Adam Ritchie Headshot.e136cab2.jpeg";